import { z } from 'zod';
/**
 * Schemas + DTOs für das Skill `input-repository` (Paket F, Issue #82).
 *
 * Konzept: Pro Projekt eine Inbox aller „Inputs“ — Dokumente, Clipboard-Schnipsel,
 * Notizen, Mail-Bodies. Backend speichert + verwaltet, Frontend zeigt Liste +
 * Detail + Apply-to-Field-Buttons.
 *
 * Extraction-Output landet in `InputArtifact.extractedFields` und wird vom
 * Sibling-Skill `ai-content-extraction` befüllt — wir liefern ihn nur aus.
 */
export const inputKind = z.enum(['mail', 'document', 'clipboard_text', 'clipboard_image', 'note']);
export const createInputJsonRequest = z
    .object({
    kind: z.enum(['clipboard_text', 'note']),
    content: z.string().min(1).max(50_000),
    source: z.string().max(200).optional(),
    filename: z.string().max(200).optional(),
})
    .strict();
export const applyInputFieldsRequest = z
    .object({
    fieldMappings: z.record(z.string(), z.unknown()),
})
    .strict();
export const listInputsQuery = z
    .object({
    kind: inputKind.optional(),
    limit: z.coerce.number().int().positive().max(200).optional(),
    offset: z.coerce.number().int().nonnegative().optional(),
})
    .strict();
